import { Box, Button, Paper, styled } from '@mui/material';

export const FileWrapper = styled(Paper)(({ theme, onClick, onDoubleClick }) => ({
  padding: theme.spacing(2),
  width: '100%',
  maxWidth: '208px',
  flexShrink: 1,
  boxSizing: 'border-box',
  containerType: 'inline-size',
  overflow: 'hidden',
  position: 'relative',
  ...(!!onClick || !!onDoubleClick
    ? {
        cursor: 'pointer',
        transition: 'transform 120ms ease, box-shadow 120ms ease, background-color 120ms ease',
        '&:hover': {
          boxShadow: theme.shadows[4],
          backgroundColor: theme.palette.action.hover,
        },
        '&:active': {
          transform: 'scale(0.98)',
          backgroundColor: theme.palette.action.selected,
        },
      }
    : {}),
  '&:hover .file-item-desktop-actions, &:focus-within .file-item-desktop-actions': {
    opacity: 1,
    pointerEvents: 'auto',
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
  },
  [theme.breakpoints.down('md')]: {
    padding: 0,
    maxWidth: 'none',
  },
  '@container (max-width: 70px)': {
    padding: theme.spacing(0.5),
  },
  '@container (max-width: 50px)': {
    padding: theme.spacing(0.25),
  },
}));

export const ImageContainer = styled('div')({
  width: '100%',
  aspectRatio: '16 / 10',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '@container (max-width: 100px)': {
    display: 'none',
  },
});

export const TextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    padding: '0 4px',
  },
  '@container (max-width: 70px)': {
    '& > div:first-of-type': {
      display: 'none',
    },
  },
}));

export const Image = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

export const DesktopActions = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(1),
  opacity: 0,
  pointerEvents: 'none',
  backgroundColor: theme.palette.background.paper,
  transition: 'opacity 100ms ease',
}));

export const DesktopActionButton = styled(Button)(({ theme }) => ({
  justifyContent: 'flex-start',
  textTransform: 'none',
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '-2px',
    backgroundColor: theme.palette.action.focus,
  },
}));
